import { render, staticRenderFns } from "./NmtSidebarProfileChart.vue?vue&type=template&id=590ac819&scoped=true&"
import script from "./NmtSidebarProfileChart.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfileChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ac819",
  null
  
)

export default component.exports